import * as palette from "../palette";

import FocusOnMount from "../FocusOnMount";
import PropTypes from "prop-types";
import React from "react";
import { Value } from "react-powerplug";

export default function AirtableInput({ onInsert, onCancel }) {
  return (
    <div
      css={{
        width: 200,
      }}
    >
      <FocusOnMount nextTick={false}>
        {({ innerRef }) => (
          <Value initial="">
            {({ value, set }) => (
              <div>
                <input
                  ref={innerRef}
                  value={value}
                  placeholder="What's the embed code?"
                  spellCheck={false}
                  css={{
                    border: "none",
                    outline: "none",
                    backgroundColor: "transparent",
                    padding: 10,
                    width: "100%",
                    height: "100%",
                    color: palette.text,
                    "&::placeholder": {
                      color: palette.sealBlue,
                    },
                  }}
                  onChange={event => set(event.target.value)}
                  onKeyDown={handleKeyDown(value, onInsert, onCancel)}
                  onMouseDown={event => event.preventDefault()}
                />
              </div>
            )}
          </Value>
        )}
      </FocusOnMount>
    </div>
  );
}

AirtableInput.propTypes = {
  onInsert: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

function handleKeyDown(value, onInsert, onCancel) {
  return event => {
    if (event.key === "Enter" && value) {
      event.preventDefault();

      const parser = new DOMParser();

      const code = parser.parseFromString(value, "text/html");
      const iframe = code.querySelector("iframe[src]");

      if (!iframe) {
        return;
      }

      const src = iframe.getAttribute("src");
      const width = iframe.getAttribute("width");
      const height = iframe.getAttribute("height");

      if (!src.includes("airtable.com/embed")) {
        return;
      }

      onInsert({
        src,
        width: parseSize(width),
        height: parseSize(height),
      });
    }

    if (event.key === "Escape") {
      onCancel();
    }
  };
}

function parseSize(size) {
  if (!size) {
    return null;
  } else if (!/^([\d]+)$/.test(size)) {
    return size;
  } else {
    const parsed = parseInt(size, 10);
    return isNaN(parsed) ? null : parsed;
  }
}
